function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { forwardRef } from 'react';
import { su, theme } from '@arc/frontend/ui-theme';
const transitionDuration = '0.3s';
const knobSize = 22;
const slotBorderWidth = 1;
const slotWidth = 36;
const slotHeight = 18;
const onEdge = (slotHeight - knobSize) / 2 - slotBorderWidth;
const onFarEdge = slotWidth - knobSize - onEdge - slotBorderWidth * 2;
const knobStyle = isLeft => /*#__PURE__*/css({
  position: 'absolute',
  width: knobSize,
  height: knobSize,
  top: onEdge,
  left: isLeft ? onEdge : onFarEdge,
  transition: `left ${transitionDuration}, opacity ${transitionDuration} steps(2, jump-none)`
}, process.env.NODE_ENV === "production" ? "" : ";label:knobStyle;");
var _ref = process.env.NODE_ENV === "production" ? {
  name: "w1atjl",
  styles: "width:100%;height:100%"
} : {
  name: "1ldxulp-Toggle",
  styles: "width:100%;height:100%;label:Toggle;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "w1atjl",
  styles: "width:100%;height:100%"
} : {
  name: "1ldxulp-Toggle",
  styles: "width:100%;height:100%;label:Toggle;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export const Toggle = forwardRef(
// eslint-disable-next-line @typescript-eslint/no-shadow
function Toggle({
  isOn = false,
  onClick,
  knobText,
  label,
  leftLabel,
  labelStyle,
  buttonStyle,
  OnIcon,
  OffIcon,
  onIconPadding = 3,
  offIconPadding = 3,
  onColor,
  testid,
  disabled,
  ...buttonProps
}, ref) {
  return <button {...buttonProps} ref={ref} data-testid={testid} aria-pressed={isOn ? 'true' : 'false'} onClick={() => {
    if (!disabled) {
      onClick?.();
    }
  }} css={[{
    display: 'flex',
    alignItems: 'center',
    cursor: disabled ? 'not-allowed' : 'pointer',
    height: '2.75rem',
    gap: 6
  }, buttonStyle, process.env.NODE_ENV === "production" ? "" : ";label:Toggle;"]} type="button">
				{leftLabel ? <div css={[{
      color: theme.colors.palettes.primary.main
    }, labelStyle, process.env.NODE_ENV === "production" ? "" : ";label:Toggle;"]}>
						{leftLabel}
					</div> : null}
				<div css={[su.roundedFull, {
      position: 'relative',
      width: slotWidth,
      minWidth: slotWidth,
      // prevent shrinking when there is not enough room
      height: slotHeight,
      marginLeft: -onEdge,
      marginRight: -onEdge,
      borderWidth: slotBorderWidth,
      borderColor: '#82D2FF'
    }, process.env.NODE_ENV === "production" ? "" : ";label:Toggle;"]}>
					{OffIcon ? <div css={[knobStyle(isOn), {
        padding: offIconPadding,
        color: theme.colors.text.primary,
        opacity: isOn ? 0 : 1
      }, process.env.NODE_ENV === "production" ? "" : ";label:Toggle;"]}>
							<OffIcon css={_ref} />
						</div> : null}
					{OnIcon ? <div css={[knobStyle(isOn), {
        padding: onIconPadding,
        color: onColor ? theme.colors.toasts.success : theme.colors.text.primary,
        opacity: isOn ? 1 : 0
      }, process.env.NODE_ENV === "production" ? "" : ";label:Toggle;"]}>
							<OnIcon css={_ref2} />
						</div> : null}
					<div css={[su.textXs, su.roundedFull, "text-align:center;", knobStyle(!isOn), {
        lineHeight: `${knobSize}px`,
        backgroundColor: theme.colors.palettes.primary.main,
        color: theme.colors.palettes.primary.contrastText
      }, process.env.NODE_ENV === "production" ? "" : ";label:Toggle;"]} data-testid="knob">
						{knobText}
					</div>
				</div>
				{label ? <div css={[{
      color: theme.colors.palettes.primary.main
    }, labelStyle, process.env.NODE_ENV === "production" ? "" : ";label:Toggle;"]}>
						{label}
					</div> : null}
			</button>;
});